<script>
export default {
    name: "PatientPostedBillDetails",

    props: {
        patient: Object,
        showModal: Boolean,
    },

    computed: {

      grandTotal() {
  
        if(!this.patient.billItems.length) return 0;

        const billItemsFiltered = this.patient.billItems.filter(billI => billI.grandTotal);

        if(!billItemsFiltered.length) return 0;

        const billItems = billItemsFiltered.map(billI => parseFloat(billI.grandTotal));

        return billItems.reduce((gTotal, accTotal) => gTotal + accTotal);
      },
    },

    methods: {

      printPostedBillsReport() {

          window.open(`/reports/accounts-finance/posted-bill-items/print?billNo=${this.patient.bill_No}&patientID=${this.patient.patientID}`,
           '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
      },
    },
}
</script>
<template>
 <tail-modal :show="showModal" dimension="md:w-2/3 sm:w-11/12">
   <template v-slot:title>
     <h5 class="font-bold text-sm">Bill Details</h5>
   </template>
   <template v-slot:modal-body>
     <div class="w-full overflow-auto">
         <table class="table table-bordered table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr>
                    <th class="p-tiny">#</th>
                    <th class="p-tiny">Txn Date</th>
                    <th class="p-tiny">User</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Description</th>
                    <th class="p-tiny">Consultant</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Price</th>
                    <th class="p-tiny">Discount</th>
                    <th class="p-tiny">Tax</th>
                    <th class="p-tiny">Grand Total</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="(bill, idx) in patient.billItems" :key="idx">
                    <td class="p-tiny">{{ bill.invoiceDetailID }}</td>
                    <td class="p-tiny">{{ bill.txnDate | dateFormat }}</td>
                    <td class="p-tiny">{{ bill.userName }}</td>
                    <td class="p-tiny">{{ bill.itemName }}</td>
                    <td class="p-tiny">{{ bill.description }}</td>
                    <td class="p-tiny">{{ bill.consultant }}</td>
                    <td class="p-tiny">{{ bill.quantity }}</td>
                    <td class="p-tiny">{{ bill.charge | numberFormat }}</td>
                    <td class="p-tiny">{{ bill.discount | numberFormat }}</td>
                    <td class="p-tiny">{{ bill.tax | numberFormat }}</td>
                    <td class="p-tiny">{{ bill.grandTotal | numberFormat }}</td>
                </tr>
            </tbody>
            <tfoot>
              <tr>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny">Total</th>
                    <th class="p-tiny">{{ grandTotal | numberFormat }}</th>
                </tr>
            </tfoot>
         </table>
     </div>
   </template>
   <template v-slot:modal-footer>
     <button class="btn-danger btn-sm text-xs rounded mr-8" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
      <button 
        class="btn-sm btn-primary text-xs rounded" 
        @click.prevent="printPostedBillsReport">
          <i class="fa fa-print"></i> Print
      </button>
   </template>
 </tail-modal>
</template>